<template>
  <div class="box">
    <h2 class="has-text-weight-bold">
      Integrantes
    </h2>
    <br />

    <b-field
      :label="
        $parent.$parent.$parent.oe.numberOfStudents
          ? 'Número de integrantes da graduação*'
          : ''
      "
      label-position="on-border"
    >
      <b-input
        v-model="$parent.$parent.$parent.oe.numberOfStudents"
        type="number"
        placeholder="Número de integrantes da graduação*"
        expanded
      ></b-input>
    </b-field>

    <br />
    <p>Informe a distribuição dos integrantes da OE por curso*</p>
    <br />

    <div
      v-for="(entry, index) in $parent.$parent.$parent.oe.membersPerCourse"
      :key="`course-${index}`"
      style="margin-bottom: 1rem"
    >
      <course-and-quantity
        :entry="entry"
        :index="index"
        @add-entry="addCourseEntry"
        @remove-entry="removeCourseEntry"
      />
    </div>

    <br />
    <p>Diversidade & Inclusão - Sua OE já está avançando nesta direção?</p>
    <br />

    <div class="columns">
      <div class="column">
        <b-field
          :label="
            $parent.$parent.$parent.oe.numberOfWomenStudents
              ? 'Número de mulheres'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.numberOfWomenStudents"
            type="number"
            placeholder="Número de mulheres"
            expanded
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="
            $parent.$parent.$parent.oe.numberOfBlackStudents
              ? 'Número de Negros (pretos + pardos)'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.numberOfBlackStudents"
            type="number"
            placeholder="Número de Negros (pretos + pardos)"
            expanded
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field
          :label="
            $parent.$parent.$parent.oe.numberOfLGBTStudents
              ? 'Integrantes LGBTQIA+'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.numberOfLGBTStudents"
            placeholder="Integrantes LGBTQIA+"
            maxlength="1500"
            type="number"
            rows="3"
            style="margin-top: 0.5rem;"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="
            $parent.$parent.$parent.oe.otherMinorities
              ? 'Minorias (detalhe por minoria)'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            v-model="$parent.$parent.$parent.oe.otherMinorities"
            placeholder="Detalhe por minoria. Ex: Indígenas (3), Imigrantes (2), Idosos (1), Moradores de vilas / favelas (1)"
            maxlength="1500"
            type="textarea"
            rows="3"
            style="margin-top: 0.5rem;"
          ></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import courseAndQuantity from "../CourseAndQuantity";

export default {
  components: {
    courseAndQuantity
  },

  methods: {
    addCourseEntry() {
      this.$parent.$parent.$parent.oe.membersPerCourse.push({
        course: "",
        quantity: ""
      });
    },

    removeCourseEntry(index) {
      if (this.$parent.$parent.$parent.oe.membersPerCourse.length > 1) {
        this.$parent.$parent.$parent.oe.membersPerCourse.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
.Box {
  max-width: 800px !important;
  margin: auto;
}
</style>
